import { render, staticRenderFns } from "./BasePreview.vue?vue&type=template&id=7cb7c348&"
import script from "./BasePreview.vue?vue&type=script&lang=js&"
export * from "./BasePreview.vue?vue&type=script&lang=js&"
import style0 from "./BasePreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports